import React, { useEffect, useRef } from 'react';
import WelcomePageBanner from "../../assets/images/WelcomePageBanner.png";
import Footer from './Footer';
import Navbar from '../Header/Navbar';
import { Link, useNavigate } from 'react-router-dom';
import { TbArrowBackUp } from 'react-icons/tb';

function FAQ() {
    const scrollableRef = useRef(null);
    const navigate = useNavigate()
    useEffect(() => {
        if (scrollableRef.current) {
            scrollableRef.current.focus();
        }
    }, []);
    return (
        <>
            {/* <Navbar></Navbar> */}
            <section
                ref={scrollableRef}
                tabIndex={0}
                className="h-[100vh] bg-white overflow-auto relative"
                style={{
                    background: `url(${WelcomePageBanner})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    height: "100vh",
                }}
            >
                 <Link
                          onClick={()=>navigate(-1)}
                          className="absolute top-2 left-2 flex items-center justify-center bg-black/20 rounded-full p-2.5 cursor-pointer"
                          title="Se déconnecter"
                        >
                          <TbArrowBackUp size={"26px"} className="text-orange-500" />
                        </Link>
                <div className="max-w-5xl mx-auto my-7 bg-white/5 rounded-lg backdrop-blur-xl text-white p-6">
                    <h1 className="text-3xl my-5 text-center font-bold mb-4">FAQ Maya+</h1>
                    <h2 className=" text-2xl font-semibold mt-8 mb-2">Qu’est-ce que MAYA+ ?</h2>
                    <p>Bien plus qu'une simple plateforme de streaming, MAYA+ est une invitation à découvrir un monde de divertissement intelligent et éducatif, à explorer le cinéma indépendant sous un nouvel angle et à partager des moments précieux en famille.</p>

                    <h2 className="text-2xl font-semibold mt-4 mb-2">Comment puis-je me désabonner ?</h2>
                    <p>Fini les casse-têtes liés à l'envoi de mails, vous avez la possibilité de mettre fin à votre abonnement à tout moment, rapidement et facilement.</p>

                    <h2 className="text-2xl font-semibold mt-4 mb-2">Quel est le tarif de MAYA+ ?</h2>
                    <p>Profitez d'une multitude de contenus pour toute la famille pour seulement 9€99 par mois.</p>

                    <h2 className="text-2xl font-semibold mt-4 mb-2">À quoi servent les filtres ?</h2>
                    <p>N’avez-vous pas connu ces moments gênants en famille lorsque vous regardez un film à la télévision et que tout d’un coup : « PAF » on saute sur la télécommande pour zapper ?<br />
                        Scène intime, de nudité ou de vulgarité ? Avec MAYA+ fini ces moments gênants !<br />
                        Selon votre profil de sensibilité, vous avez la possibilité d'activer le ou les filtres que vous souhaitez. Pour éliminer les images et les sons inappropriés et profiter d'un cinéma en famille en toute tranquillité !</p>

                    <h2 className="text-2xl font-semibold mt-4 mb-2">Comment utiliser les filtres ?</h2>
                    <p>Par défaut, tous les filtres seront activés. Le seul filtre non activé sera celui de la violence physique. Vous pourrez lors de l’édition de votre profil, activer ou désactiver le ou les filtres de votre choix.</p>

                    <h2 className="text-2xl font-semibold mt-4 mb-2">Est-ce que MAYA+ est disponible sur tous les écrans ?</h2>
                    <p>Vous pouvez regarder MAYA+ sur n'importe quel appareil connecté à internet proposant l'application MAYA+.<br />
                        REMARQUE : Il est possible qu'un petit pourcentage d'appareils ne soit pas pris en charge.</p>

                    <h2 className="text-2xl font-semibold mt-4 mb-2">Est-ce que MAYA+ est adapté aux enfants ?</h2>
                    <p>Chez Maya+, nous pensons que le divertissement peut être à la fois amusant et éducatif.<br />
                        Notre catalogue Jeunesse est conçu pour éveiller la curiosité et les questionnements des jeunes spectateurs.<br />
                        Apprendre devient un jeu grâce à notre contenu éducatif, scientifique, culturel et historique.</p>

                    <h2 className="text-2xl font-semibold mt-4 mb-2">Qu’est-ce que les MAYA+ Originals ?</h2>
                    <p>Plongez dans notre univers d'originalité avec les "Maya+ Originals".<br />
                        Créés par notre collectif d'artistes, producteurs et techniciens de l'image, ces contenus exclusifs vous offriront une expérience cinématographique hors du commun tout au long de l’année.</p>

                    <h2 className="text-2xl font-semibold mt-4 mb-2">Comment nous contacter ?</h2>
                    <p>Une question ? Une remarque ? Une suggestion ? Nous sommes disponibles pour répondre à toutes vos questions par mail à l’adresse suivante : <a href="mailto:contact@mayaplus.fr" className="text-blue-500 underline">contact@mayaplus.fr</a>.</p>
                </div>
                <div className='bg-[#151226]'>
                    <Footer></Footer>
                </div>
            </section>
        </>
    );
}

export default FAQ;
